<div class="loading-wrapper" [class.full-page]="fullPage" [class.with-overlay]="overlay">
  <div class="loading-container" [class.size-sm]="size === 'sm'" [class.size-md]="size === 'md'" [class.size-lg]="size === 'lg'">
    <div class="loading-spinner">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="62.83" stroke-dashoffset="62.83" opacity="0.3" />
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="62.83" stroke-dashoffset="47.12" />
      </svg>
    </div>
    @if (message) {
    <p class="loading-message">{{ message }}</p>
    }
  </div>
</div>

